"use strict";
export var InterfaceEventNameLocal = /* @__PURE__ */ ((InterfaceEventNameLocal2) => {
  InterfaceEventNameLocal2["PortfolioMenuOpened"] = "Portfolio Menu Opened";
  InterfaceEventNameLocal2["UniswapXOrderDetailsSheetOpened"] = "UniswapX Order Details Sheet Opened";
  InterfaceEventNameLocal2["UniswapXOrderCancelInitiated"] = "UniswapX Order Cancel Initiated";
  InterfaceEventNameLocal2["UniswapXSignatureRequested"] = "UniswapX Signature Requested";
  InterfaceEventNameLocal2["UniswapXSignatureDeadlineExpired"] = "UniswapX Signature Deadline Expired";
  InterfaceEventNameLocal2["UniswapXOrderPostError"] = "UniswapX Order Post Error";
  InterfaceEventNameLocal2["UniswapXOrderSubmitted"] = "UniswapX Order Submitted";
  InterfaceEventNameLocal2["LimitPresetRateSelected"] = "Limit Preset Rate Selected";
  InterfaceEventNameLocal2["LimitPriceReversed"] = "Limit Price Reversed";
  InterfaceEventNameLocal2["LimitExpirySelected"] = "Limit Expiry Selected";
  InterfaceEventNameLocal2["SwapTabClicked"] = "Swap Tab Clicked";
  InterfaceEventNameLocal2["LocalCurrencySelected"] = "Local Currency Selected";
  InterfaceEventNameLocal2["NoQuoteReceivedFromQuickrouteAPI"] = "No quote received from quickroute API";
  InterfaceEventNameLocal2["NoQuoteReceivedFromRoutingAPI"] = "No quote received from routing API";
  InterfaceEventNameLocal2["CreatePositionFailed"] = "Create Position Failed";
  InterfaceEventNameLocal2["IncreaseLiquidityFailed"] = "Increase Liquidity Failed";
  InterfaceEventNameLocal2["DecreaseLiquidityFailed"] = "Decrease Liquidity Failed";
  InterfaceEventNameLocal2["MigrateLiquidityFailed"] = "Migrate Liquidity Failed";
  InterfaceEventNameLocal2["CollectLiquidityFailed"] = "Collect Liquidity Failed";
  InterfaceEventNameLocal2["LiquidityFeesClaimed"] = "Liquidity Fees Claimed";
  InterfaceEventNameLocal2["LimitedWalletSupportToastShown"] = "Limited Wallet Support Toast Shown";
  InterfaceEventNameLocal2["LimitedWalletSupportToastDismissed"] = "Limited Wallet Support Toast Dismissed";
  InterfaceEventNameLocal2["LimitedWalletSupportToastLearnMoreButtonClicked"] = "Limited Wallet Support Learn More Button Clicked";
  InterfaceEventNameLocal2["DelegationDetected"] = "Delegation Detected";
  InterfaceEventNameLocal2["WalletCapabilitiesDetected"] = "Wallet Capabilities Detected";
  return InterfaceEventNameLocal2;
})(InterfaceEventNameLocal || {});
